import { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { DARK_THEME, LIGHT_THEME } from "../Constants/constantValues";
import LocalStorage from "../Helpers/LocalStorage";

export const GenericComponentsContext = createContext({
  loading: [],
  callListSpinner: [],
  messagesListSpinner: [],
  meetingListSpinner: [],
  showMessageDetailsModal: [],
  showGroupChatDetails: [],
  showQuickChatDetails: [],
  isMeetingDetailsOpen: [],
  deleteReasonModalOpen: [],
  isSubscriptionModalOpen: [],
  isBlockUsersOpen: [],
  isReferralMdalOpen: [],
  theme: [],
  selectedMenuAudioInput: [],
  selectedMenuAudioOutput: [],
  selectedMenuVideoInput: [],
  isAddNewMeetingOpen: [],
  isJoinMeetingByCodeOpen: [],
  isAddNewCallOpen: [],
  automaticTranslations: [],
  isAddNewChatOpen: [],
  isQcModalOpen: [],
  isInfoModalOpen: [],
  isLinkPhoneInfoModalOpen: [],
  setLoading: () => { },
  setCallListSpinner: () => { },
  setMessagesListSpinner: () => { },
  setMeetingListSpinner: () => { },
  setShowMessageDetailModal: () => { },
  setShowGroupChatDetails: () => { },
  setShowQuickChatDetails: () => { },
  setIsMeetingDetailsOpen: () => { },
  setDeleteReasonModalOpen: () => { },
  setIsSubscriptionModalOpen: () => { },
  setIsBlockUsersOpen: () => { },
  setIsReferralModalOpen: () => { },
  setTheme: () => { },
  toggleTheme: () => { },
  setSelectedMenuAudioInput: () => { },
  setSelectedMenuAudioOutput: () => { },
  setSelectedMenuVideoInput: () => { },
  setIsAddNewMeetingOpen: () => { },
  setIsJoinMeetingByCodeOpen: () => { },
  setIsAddNewCallOpen: () => { },
  setAutomaticTranslations: () => { },
  setIsAddNewChatOpen: () => { },
  setIsQcModalOpen: () => { },
  setIsInfoModalOpen: () => { },
  setIsLinkPhoneInfoModalOpen: () => { },

});

const GenericComponentsContextProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [callListSpinner, setCallListSpinner] = useState(false);
  const [messagesListSpinner, setMessagesListSpinner] = useState(false);
  const [meetingListSpinner, setMeetingListSpinner] = useState(false);
  const [showMessageDetailsModal, setShowMessageDetailModal] = useState(false);

  const [showGroupChatDetails, setShowGroupChatDetails] = useState(false);
  const [showQuickChatDetails, setShowQuickChatDetails] = useState(false);

  const [isMeetingDetailsOpen, setIsMeetingDetailsOpen] = useState(false);
  const [deleteReasonModalOpen, setDeleteReasonModalOpen] = useState(false);

  const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] = useState(false);
  const [isBlockUsersOpen, setIsBlockUsersOpen] = useState(false);
  const [isReferralMdalOpen, setIsReferralModalOpen] = useState(false);

  const [selectedMenuAudioInput, setSelectedMenuAudioInput] = useState(null);
  const [selectedMenuAudioOutput, setSelectedMenuAudioOutput] = useState(null);
  const [selectedMenuVideoInput, setSelectedMenuVideoInput] = useState(null);

  const [isAddNewMeetingOpen, setIsAddNewMeetingOpen] = useState(false);
  const [isJoinMeetingByCodeOpen, setIsJoinMeetingByCodeOpen] = useState(false);
  const [isAddNewCallOpen, setIsAddNewCallOpen] = useState(false);

  const [automaticTranslations, setAutomaticTranslations] = useState(false);
  const [isAddNewChatOpen, setIsAddNewChatOpen] = useState(false);
  const [isQcModalOpen, setIsQcModalOpen] = useState(false);
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [isLinkPhoneInfoModalOpen, setIsLinkPhoneInfoModalOpen] = useState(false);

  const [theme, setTheme] = useState(DARK_THEME);

  const toggleTheme = useCallback(() => {
    setTheme(theme === LIGHT_THEME ? DARK_THEME : LIGHT_THEME);
  }, [theme]);

  useEffect(() => {
    const localTheme = LocalStorage.getAppTheme();
    const automaticTranslateLocal = LocalStorage.getAutomaticTranslate();

    if (localTheme) {
      setTheme(localTheme);
      if (localTheme === "light") {
        document.documentElement.classList.toggle("dark");
      }
    }

    if (automaticTranslateLocal === "true") {
      setAutomaticTranslations(true);
    }
    if (automaticTranslateLocal === "false") {
      setAutomaticTranslations(false);
    }
  }, []);

  const contextValue = useMemo(
    () => ({
      theme,
      setTheme,
      toggleTheme,
      loading,
      setLoading,
      callListSpinner,
      setCallListSpinner,
      messagesListSpinner,
      setMessagesListSpinner,
      meetingListSpinner,
      setMeetingListSpinner,
      showMessageDetailsModal,
      setShowMessageDetailModal,
      showGroupChatDetails,
      setShowGroupChatDetails,
      showQuickChatDetails,
      setShowQuickChatDetails,
      isMeetingDetailsOpen,
      setIsMeetingDetailsOpen,
      deleteReasonModalOpen,
      setDeleteReasonModalOpen,
      isSubscriptionModalOpen,
      setIsSubscriptionModalOpen,
      isBlockUsersOpen,
      setIsBlockUsersOpen,
      isReferralMdalOpen,
      setIsReferralModalOpen,
      selectedMenuAudioInput,
      setSelectedMenuAudioInput,
      selectedMenuAudioOutput,
      setSelectedMenuAudioOutput,
      selectedMenuVideoInput,
      setSelectedMenuVideoInput,
      isAddNewMeetingOpen,
      setIsAddNewMeetingOpen,
      isJoinMeetingByCodeOpen,
      setIsJoinMeetingByCodeOpen,
      isAddNewCallOpen,
      setIsAddNewCallOpen,
      automaticTranslations,
      setAutomaticTranslations,
      isAddNewChatOpen,
      setIsAddNewChatOpen,
      isQcModalOpen,
      setIsQcModalOpen,
      isInfoModalOpen,
      setIsInfoModalOpen,
      isLinkPhoneInfoModalOpen,
      setIsLinkPhoneInfoModalOpen,
    }),
    [
      theme,
      toggleTheme,
      loading,
      callListSpinner,
      messagesListSpinner,
      meetingListSpinner,
      showMessageDetailsModal,
      showGroupChatDetails,
      showQuickChatDetails,
      isMeetingDetailsOpen,
      deleteReasonModalOpen,
      isSubscriptionModalOpen,
      isBlockUsersOpen,
      isReferralMdalOpen,
      selectedMenuAudioInput,
      selectedMenuAudioOutput,
      selectedMenuVideoInput,
      isAddNewMeetingOpen,
      isJoinMeetingByCodeOpen,
      isAddNewCallOpen,
      automaticTranslations,
      isAddNewChatOpen,
      isQcModalOpen,
      isInfoModalOpen,
      isLinkPhoneInfoModalOpen,
    ]
  );

  return (
    <GenericComponentsContext.Provider value={contextValue}>
      {children}
    </GenericComponentsContext.Provider>
  );
};

export const useGenericComponentsStateService = () =>
  useContext(GenericComponentsContext);

export default GenericComponentsContextProvider;
